import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'motion/react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { notificationsApi } from '../../api/notifications';
import { useNotificationStore } from '../../stores/notificationStore';
import { useToast } from '../ui/Toaster';
import { Spinner } from '../ui/Spinner';

export function AnalyzeProjectsButton() {
  const { t, i18n } = useTranslation('notifications');
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const fetchNotifications = useNotificationStore((s) => s.fetchNotifications);
  const toast = useToast();

  const handleAnalyze = async () => {
    setIsAnalyzing(true);
    try {
      const response = await notificationsApi.analyzeProjects(i18n.language);

      // Refresh notifications to show new alerts
      await fetchNotifications();

      if (response.alerts.length > 0) {
        toast.success(
          t('analyze.success'),
          t('analyze.alertsGenerated', { count: response.alerts.length })
        );
      } else {
        toast.info(
          t('analyze.noAlerts'),
          t('analyze.allProjectsOk')
        );
      }
    } catch (error: any) {
      if (error.message?.includes('503') || error.message?.includes('AI_NOT_CONFIGURED')) {
        toast.error(t('analyze.aiNotConfigured'));
      } else {
        toast.error(error.message || t('analyze.error'));
      }
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleAnalyze}
      disabled={isAnalyzing}
      className="relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-800 text-gray-600 dark:text-slate-400 disabled:opacity-50"
      title={t('analyze.title')}
    >
      {isAnalyzing ? (
        <Spinner size="sm" />
      ) : (
        <SparklesIcon className="h-5 w-5" />
      )}
    </motion.button>
  );
}
